import { Descriptions } from "antd";
import PropTypes from "prop-types";
import displayValue from "../../../../utilities/displayValue";

function CarDetailFieldTable({ rows, naFallback = "N/A", title, column = 1, className = "" }) {
    return (
        <div className={`mx-4 mb-4 min-w-0 ${className}`.trim()}>
            {title && <h3 className="fontbold mb-3 text-base text-[#121212]">{title}</h3>}

            <div className="lg:hidden min-w-0 divide-y divide-[#f0f0f0] overflow-hidden rounded-lg border border-[#f0f0f0]">
                {rows.map((row) => (
                    <div key={String(row.label)} className="flex min-w-0 flex-col gap-1 px-3 py-3">
                        <span className="text-xs font-medium text-[#acacb9]">{row.label}</span>
                        <div className="min-w-0 break-words text-sm text-[#121212]">
                            {row.render ? row.render() : displayValue(row.value, naFallback)}
                        </div>
                    </div>
                ))}
            </div>

            <div className="hidden min-w-0 overflow-x-auto lg:block">
                <Descriptions
                    column={column}
                    size="small"
                    bordered
                    className="car-detail-descriptions min-w-[280px] break-words">
                    {rows.map((row) => (
                        <Descriptions.Item key={String(row.label)} label={row.label} span={row.span || 1}>
                            {row.render ? row.render() : displayValue(row.value, naFallback)}
                        </Descriptions.Item>
                    ))}
                </Descriptions>
            </div>
        </div>
    );
}

CarDetailFieldTable.propTypes = {
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.node.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
            render: PropTypes.func,
            span: PropTypes.number,
        }),
    ).isRequired,
    naFallback: PropTypes.string,
    title: PropTypes.string,
    column: PropTypes.number,
    className: PropTypes.string,
};

export default CarDetailFieldTable;
